module.exports = __webpack_public_path__ + "media/images/grabbing-d817e1dba5bd5d891d0504bf1715807b.png";